<template>
  <v-container fill-height>
    <v-layout column justify-center align-center>
      <v-progress-circular
        class=""
        indeterminate
        :size="70"
        :width="7"
        color="primary"
      ></v-progress-circular>

      <span class="mt-5 grey--text text--darken-1" style="font-size: 16px">
        Loading questionnaire. This process may take a few minutes.<br />
        Thank you for your patience.
      </span>
    </v-layout>
  </v-container>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      questionnaireTemplate: null,
    };
  },

  methods: {
    async checkQuestionnaireExists() {
      if (this.questionnaireTemplate.is_annual) {
        const {
          data: { questionnaire_id },
        } = await API.resource.getQuestionnaireIdByTemplate({
          hashId: this.hashId,
          username: this.currentUser.email,
          taxYear: this.taxYear,
        });

        return questionnaire_id || null;
      } else {
        return null;
      }
    },

    async createQuestionnaire() {
      const response = await API.auth.firmSelfSignUpCreateQuestionnaire({
        templateHashId: this.hashId,
        year: this.taxYear,
      });

      if (response.data.error) {
        this.$store.dispatch('application/setErrorNotification', {
          message: response.data.error,
        });
        console.log(response.data.error);
      } else {
        this.$router.push(
          `/questionnaire?questionnaireId=${response.data.questionnaire_id}`,
        );
      }
    },

    async getTemplate() {
      try {
        const response = await API.resource.getTemplate(this.hashId);
        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Invalid Link',
          });
          this.$router.push('/signin');
        }
        this.questionnaireTemplate = response.data;
      } catch (e) {
        console.log(e);
      }
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),

    hashId() {
      return this.$route.query.hashId;
    },

    taxYear() {
      return this.$route.query.taxYear;
    },
  },

  async created() {
    if (this.currentUser.is_advisor) {
      this.$store.dispatch('application/setErrorNotification', {
        message:
          "Couldn't create a questionnaire because you are logged in as a firm user.",
      });
      this.$router.push('/overview');
    } else if (this.hashId && this.taxYear) {
      await this.getTemplate();

      const questionnaire_id = await this.checkQuestionnaireExists();

      if (questionnaire_id !== null) {
        this.$router.push('/questionnaire?questionnaireId=' + questionnaire_id);
      } else {
        await this.createQuestionnaire();
      }
    }
  },
};
</script>

<style lang="postcss" scoped></style>
